import Image from "aldoo-ra/Image"
import Typography from "aldoo-ra/Typography"
import Text from "aldoo-ra/Text"
import MenuGroup from "aldoo-ra/MenuGroup"
import Copyright from "../Copyright"
import PoweredBy from "../PoweredBy"
import LogoFull from "../Logo/LogoFull"
import PubSub from "pubsub-js"

const getOpenParam = (item) => {
  const linkParams = item.link?.[0]?.content?.parameters || item.link?.[0]?.parameters
  if (linkParams?.open) return linkParams.open
  const p = item.parameters
  if (!p) return null
  if (Array.isArray(p)) return p.find(e => e.key === "open")?.value || null
  return p.open || null
}

function scrollToHash(url) {
  if (!url?.includes("#")) return false
  const hash = "#" + url.split("#")[1]
  const el = document.querySelector(hash)
  if (el) {
    el.scrollIntoView({ behavior: "smooth" })
    history.replaceState(history.state, "", hash)
    return true
  }
  return false
}

export default function FooterDesktop({ onOpenContactSales }) {
  return (
    <footer className="relative bg-footer pt-16 pb-8">
      <div className="w-full max-w-w1_xl mx-auto px-px_sm md:px-px_md">
        {/* Top: logo + link groups */}
        <div className="flex flex-row items-start justify-between gap-10 mb-12">
          {/* Brand column */}
          <div className="pt-2">
            <div className="w-[150px]">
              <LogoFull textColor = "text_inv" />
            </div>

            <Text 
              id="footer_tagline" 
              variant="txt" 
              className="block max-w-[500px] text-neutral_2 leading-relaxed mt-4"
            />
          </div>

          {/* Link groups */}
          <div className="flex items-start justify-end gap-10 md:gap-16 lg:gap-24 xl:gap-[140px]">
              {/* Product Group */}
              <MenuGroup
                renderAs={"vlist"}
                name="FooterGroupProduct"
                itemsAsLinks={false}
                styleOverrides={{
                  menu_column: "hidden",
                  menu_item: "px-0 my-4"
                }}
                rootItemRender={(item) => {
                  return (
                    <Typography 
                      variant="footer_group_label" 
                      className=""
                    >
                      {item.label}
                    </Typography>
                  )
                }}
                menuItemRender={(item) => {
                  const url = item.link?.[0]?.url
                  return <a
                      href={url}
                      onClick={(e) => {
                        if (scrollToHash(url)) {
                          e.preventDefault()
                          e.stopPropagation()
                        }
                      }}
                    >
                      <Typography variant="footer_item">
                        {item.label}
                      </Typography>
                    </a>
                }}
              />

              {/* Company Group */}
              <MenuGroup
                renderAs={"vlist"}
                name="FooterGroupCompany"
                itemsAsLinks={false}
                styleOverrides={{
                  menu_column: "hidden",
                  menu_item: "px-0 my-4"
                }}
                rootItemRender={(item) => {
                  return (
                    <Typography 
                      variant="footer_group_label" 
                      className=""
                    >
                      {item.label}
                    </Typography>
                  )
                }}
                menuItemRender={(item) => {
                  const url = item.link?.[0]?.url
                  return <a
                      href={url}
                      target="_blank"
                      onClick={(e) => {
                        if (scrollToHash(url)) {
                          e.preventDefault()
                          e.stopPropagation()
                        }
                      }}
                    >
                      <Typography variant="footer_item">
                      {item.label.startsWith("Aldoo ")
                        ? <><strong>Aldoo</strong>{item.label.slice(5)}</>
                        : item.label}
                      </Typography>
                    </a>
                }}
              />

              {/* Support Group */}
              <MenuGroup
                renderAs={"vlist"}
                name="FooterGroupSupport"
                itemsAsLinks={false}
                styleOverrides={{
                  menu_column: "hidden",
                  menu_item: "px-0 my-4"
                }}
                rootItemRender={(item) => {
                  return (
                    <Typography 
                      variant="footer_group_label" 
                      className=""
                    >
                      {item.label}
                    </Typography>
                  )
                }}
                menuItemRender={(item) => {
                  const openParam = getOpenParam(item)
                  if (openParam) {
                    return (
                      <button onClick={() => PubSub.publish(`open:${openParam}`)}>
                        <Typography variant="footer_item">{item.label}</Typography>
                      </button>
                    )
                  }
                  const url = item.link?.[0]?.url
                  if (url && /#contact/.test(url)) {
                    return (
                      <button onClick={onOpenContactSales}>
                        <Typography variant="footer_item">{item.label}</Typography>
                      </button>
                    )
                  }
                  return <a
                      href={url}
                      onClick={(e) => {
                        if (scrollToHash(url)) {
                          e.preventDefault()
                          e.stopPropagation()
                        }
                      }}
                    >
                      <Typography variant="footer_item">
                      {item.label}
                      </Typography>
                    </a>
                }}
              />

          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-neutral_3/50 mb-8" />

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <Copyright />
          <PoweredBy />
        </div>
      </div>
    </footer>
  )
}